//@flow
import React from 'react';
import {makeStyles, TableCell} from '@material-ui/core';
import {useTableCells} from '../../context/CellContext';

const useStyles = makeStyles(theme => ({
  cell: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 'max-content',
  },
}));

function ProductCellsList() {
  const classes = useStyles();

  const activeCells = useTableCells();

  return (
    <>
      {activeCells.map(({CellComponent, id}, index) => {
        if (index === 0) {
          return (
            <TableCell scope="row" key={`${id}-${index}`}>
              <div className={classes.cell}>
                <CellComponent />
              </div>
            </TableCell>
          );
        }

        return <CellComponent key={`${id}-${index}`} />;
      })}
    </>
  );
}

//$FlowFixMe
export default React.memo(ProductCellsList);
